import { render, staticRenderFns } from "./getempimage.vue?vue&type=template&id=1cc819ce&"
import script from "./getempimage.vue?vue&type=script&lang=js&"
export * from "./getempimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
})
